import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance";

export const createNewRole = (
  queryParams: {
    title: string,
    description: string,
    permissions: string[]
  }) => {
  return axiosPrivate.post(`/dashboard/v1/roles/role_create`, queryParams);
};